import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { BsFillTelephoneFill } from "react-icons/bs";
import { CallManagementEvent } from "../../models/call-management.model";
import TwilioVoiceService from "../../services/twilio/twilio-voice.service";
import { getCallCenterPreferences } from "../../services/call-center/call-center-preferences.service";
import CallPresenter from "../call-presenter/CallPresenter.component";

const UiCallBar = () => {
	const { t } = useTranslation("common");
	const [state, setState] = useState<CallManagementEvent>();
	const [collapsed, setCollapsed] = useState(false);
	const hadCallsRef = useRef(false);

	useEffect(() => {
		TwilioVoiceService.initialize();
		const subscription = TwilioVoiceService.callManagementSubject.subscribe(
			(event?: CallManagementEvent) => {
				const hasCalls = (event?.callManagementState?.calls?.length ?? 0) > 0;
				// First call of a session: honor the coach's auto-open preference
				if (hasCalls && !hadCallsRef.current)
					setCollapsed(!getCallCenterPreferences().autoOpenCallBar);
				hadCallsRef.current = hasCalls;
				setState(event);
			}
		);
		return () => subscription.unsubscribe();
	}, []);

	const calls = state?.callManagementState?.calls ?? [];
	if (calls.length === 0) return <></>;

	if (collapsed)
		return (
			<button
				type="button"
				className="k-call-bar-pill"
				title={t("UI_COMPONENTS.CALL_MANAGEMENT.BAR_EXPAND")}
				aria-label={t("UI_COMPONENTS.CALL_MANAGEMENT.BAR_EXPAND")}
				onClick={() => setCollapsed(false)}
			>
				<BsFillTelephoneFill />
				<span className="k-call-bar-pill__count">{calls.length}</span>
			</button>
		);

	return (
		<div className="k-call-bar">
			{TwilioVoiceService.state.calls.map((callItem) => (
				<CallPresenter
					key={callItem.state.id}
					callPresenter={callItem}
					onMinimize={() => setCollapsed(true)}
				></CallPresenter>
			))}
		</div>
	);
};

export default UiCallBar;
